<h4 class="mb-4" style="font-size: 18px;">Journal Entry Details</h4>
<div class="row">
    <div class="col-6">
        <div>
            <span class="font-weight-bold">Entry Date: </span>
            <span>{{ transaction.transactionDate | legfiDate:'MM/DD/YYYY' }}</span>
        </div>
        <div>
            <span class="font-weight-bold">Description: </span>
            <span>{{ transaction.description }}</span>
        </div>
    </div>
    <div class="col-6">
        <div>
            <span class="font-weight-bold">Memo: </span>
            <span>{{ transaction.memo }}</span>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <div class="font-weight-bold text-underline text-center">Debits</div>
        <hr class="mt-0">
        <ul class="summary">
            <li *ngFor="let entry of debitEntries">
                <span class="bg-light font-weight-bold">{{ entry.class.label || entry.class.name }}</span>
                <span class="bg-light" [innerHTML]="entry.amount | legfiBalance:'USD':'symbol':'.2'"></span>
            </li>
        </ul>
    </div>
    <div class="col-md-6">
        <div class="font-weight-bold text-underline text-center">Credits</div>
        <hr class="mt-0">
        <ul class="summary">
            <li *ngFor="let entry of creditEntries">
                <span class="bg-light font-weight-bold">{{ entry.class.label || entry.class.name }}</span>
                <span class="bg-light" [innerHTML]="entry.amount | legfiBalance:'USD':'symbol':'.2'"></span>
            </li>
        </ul>
    </div>
</div>
